import Overview from '@rebuild/materials/shared/investment_activity/flowX/FlowXOverviewInHK09606.vue';
import FullIndex from '@rebuild/materials/shared/investment_activity/FullIndex.vue';
import MobOverviewIndex from '@rebuild/materials/shared/investment_activity/mobile/OverviewIndex.vue';
import MobFullIndex from '@rebuild/materials/shared/investment_activity/mobile/FullIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { useSelfContext } from './useSelfContext';

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(FullIndex, useSelfContext),
	'mob-overview': withProvider(MobOverviewIndex, useSelfContext),
	'mob-full': withProvider(MobFullIndex, useSelfContext)
};
